
import { Navigate, Outlet, Routes, Route } from "react-router-dom";
import DashboardPage from "@/pages/DashboardPage";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { CategoryRoutes } from "./CategoryRoutes";
import { ContractRoutes } from "./ContractRoutes";
import { ContractTypeRoutes } from "./ContractTypeRoutes";
import { CurrencyRoutes } from "./CurrencyRoutes";
import { ContactRoutes } from "./ContactRoutes";
import { GroupRoutes } from "./GroupRoutes";
import { AdminRoutes } from "./AdminRoutes";
import { ApiIntegrationRoutes } from "./ApiIntegrationRoutes";
import { ServiceRoutes } from "./ServiceRoutes";
import ProfilePage from "@/pages/ProfilePage";
import SettingsPage from "@/pages/settings/SettingsPage";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import NotFound from "@/pages/NotFound";
import IndexPage from "@/pages/IndexPage";
import { useAuth } from "@/hooks/useAuth";

export function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <IndexPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      
      {/* Protected routes */}
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      
      {/* Include all admin routes */}
      {AdminRoutes()}
      
      {/* Include API integration routes */}
      {ApiIntegrationRoutes()}
      
      {/* Include all route groups with feature protection */}
      {CategoryRoutes()}
      {ContractRoutes()}
      {ContractTypeRoutes()}
      {CurrencyRoutes()}
      {ContactRoutes()}
      {GroupRoutes()}
      
      {/* Service routes require contract_services feature */}
      <Route path="/services/*" element={
        <ProtectedRoute>
          <Outlet />
        </ProtectedRoute>
      }>
        {ServiceRoutes().props.children}
      </Route>
      
      {/* Catch-all route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
